<template>
  <div>
    <!--    기본정보-->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint"/>

<!--    유해·위험요인 분야-->
    <vs-row class="mt-6">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5>
          <i class="dot"></i> 유해·위험요인 분야
        </h5>
      </vs-col>
    </vs-row>
    <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
      <div
        class="col-span-2 flex items-center"
        v-for="(row, indexRows) in form.checkList"
        :key="indexRows"
      >
        <div v-if="isPrint" class="flex items-center">
          <div
            v-if="row.check"
            style="background: #200c63"
            class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2"
          >
            <vs-icon icon="check" size="x-small"></vs-icon>
          </div>
          <div
            v-else
            style="border: 2px solid rgb(180, 180, 180)"
            class="w-5 h-5 rounded-sm mr-2"
          ></div>
          <span class="flex-1">
            {{ row.title }}
          </span>
        </div>
        <div v-else>
          <span class="flex">
            <vs-checkbox
              :readonly="board.readonly"
              v-model="row.check"
              @change="changeCheckType($event, indexRows)"
            ></vs-checkbox>
            {{ row.title }}
          </span>
        </div>
      </div>
    </div>

    <div
      v-for="(row, indexRows) in form.checkList"
      :key="indexRows"
      class="mt-5">
      <table-inspect
        :is-print="isPrint"
        :is-readonly="board.readonly"
        :is-show-title="false"
        :is-note="true"
        :list="row.inspectList"
        :table-header-title="row.title"
        :table-header-yes="'작성'"
        :table-header-no="'미작성'"
        :table-header-note="'비고'"
        @update-list-check="(param1, param2)=>{updateListCheck(indexRows,param1,param2)}"
        @update-note="(param1, param2)=>{updateListNote(indexRows,param1,param2)}"
        v-if="row.check"
      />
    </div>


    <!--    사진대지-->
    <photo-upload-grid-module
      
      v-model="form.photoList"
      :is-print="isPrint"
      :readonly="board.readonly"
      section-title="사진대지"
      placeholder="신축현장 사진"/>

    <!--    파일첨부-->
    <file-upload-module
      id="fileList"
      class="w-full mt-4"
      v-model="form.fileList"
      :is-print="isPrint"
      :readonly="board.readonly"></file-upload-module>

  </div>
</template>

<script>
import PopupPlanProject from '@/views/project/popup/PopupPlanProject'
import DateSelector from '@/components/selector/DateSelector'
import PopupProjectSetting from '@/views/project/PopupProjectSetting'
import MemberSelector from '@/components/selector/MemberSelector'
import CompanySelector from '@/components/selector/CompanySelector'
import FileUploader from '@/components/FileUploader'
import FileUploadModule from '@/views/modules/FileUploadModule'
import TableInspect from '@/components/TableInspect'
import TableEquipment from '@/components/TableEquipment'
import DisasterClassSelector from '@/components/selector/DisasterClassSelector'
import FieldSelectModule from '@/views/modules/FieldSelectModule'
import PhotoUploadGridModule from '@/views/modules/PhotoUploadGridModule'

export default {
  components: {
    PhotoUploadGridModule,
    FieldSelectModule,
    FileUploadModule,
    TableInspect,
    TableEquipment,
    DisasterClassSelector,
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler (value) {
        const keys = Object.keys(this.form)
        for (const key of keys) {
          if (key === 'checkList' && !value[key]) {
            //
          } else {
            if (value[key]) {
              this.form[key] = value[key];
            }
          }
        }
        if (this.form.checkList) {
          for (const data of this.form.checkList) {
            if (!data.inspectList || data.inspectList.length === 0) {
              data.inspectList = this.inspectTable(data.title)
            }
          }
        }
      }
    },
    form: {
      immediate: true,
      deep: true,
      handler (value) {
        if (value.checkList) {
          this.form.typeTitle
            = `${value.checkList[0].check ? value.checkList[0].title : ''}
            ${value.checkList[1].check ? value.checkList[1].title : ''}
             ${value.checkList[2].check ? value.checkList[2].title : ''}
              ${value.checkList[3].check ? value.checkList[3].title : ''}
               ${value.checkList[4].check ? value.checkList[4].title : ''}
            ${value.checkList[5].check ? value.checkList[5].title : ''}`
        }
        this.$emit('input', value)
      }
    }
  },
  data () {
    return {
      form: {
        stdInfo: { },

        photoList: [],
        fileList: [],
        checkList: [
          {title: '기계적 요인', check: true, inspectList:[]},
          {title: '전기적 요인', check: false, inspectList:[]},
          {title: '화학(물질)적 요인', check: false, inspectList:[]},
          {title: '생물학적 요인', check: false, inspectList:[]},
          {title: '작업특성 요인', check: false, inspectList:[]},
          {title: '작업환경 요인', check: false, inspectList:[]},
        ],
        typeTitle: '',
      },
    }
  },
  methods : {
    updateListCheck (indexList, indexRows, text) {
      this.form.checkList[indexList].inspectList[indexRows].is_checked = text
    },

    updateListNote (indexList, indexRows, text) {
      this.form.checkList[indexList].inspectList[indexRows].note = text
    },

    inspectTable (title) {
      switch (title) {
      case '기계적 요인' :
        return [
          {
            id: 1,
            label: '협착 위험(감김, 끼임)',
            is_checked: '',
            note: '',
          },
          {
            id: 2,
            label: '위험한 표면(절단, 베임, 긁힘)',
            is_checked: '',
            note: '',
          },
          {
            id: 3,
            label: '기계(설비)의 낙하, 비래, 전복, 붕괴, 전도 위험',
            is_checked: '',
            note: '',
          },
          {
            id: 4,
            label: '충돌 위험',
            is_checked: '',
            note: '',
          },
          {
            id: 5,
            label: '넘어짐 위험(미끄러짐, 걸림, 헛디딤)',
            is_checked: '',
            note: '',
          },
          {
            id: 6,
            label: '추락 위험',
            is_checked: '',
            note: '',
          },

        ]
      case '전기적 요인' :
        return [
          {
            id: 1,
            label: '감전(안전전압 초과)',
            is_checked: '',
            note: '',
          },
          {
            id: 2,
            label: '아크',
            is_checked: '',
            note: '',
          },
          {
            id: 3,
            label: '정전기',
            is_checked: '',
            note: '',
          },
          {
            id: 4,
            label: '화재/폭발 위험',
            is_checked: '',
            note: '',
          },
        ]
      case '화학(물질)적 요인' :
        return [
          {
            id: 1,
            label: '가스,증기,에어로졸,흄',
            is_checked: '',
            note: '',
          },
          {
            id: 2,
            label: '액체,미스트,고체(분진)',
            is_checked: '',
            note: '',
          },
          {
            id: 3,
            label: '반응성 물질, 방사선',
            is_checked: '',
            note: '',
          },
          {
            id: 4,
            label: '화재/폭발 위험',
            is_checked: '',
            note: '',
          },
        ]
      case '생물학적 요인' :
        return [
          {
            id: 1,
            label: '병원성 미생물, 바이러스에 의한 감염',
            is_checked: '',
            note: '',
          },
          {
            id: 2,
            label: '유전자 변형물질',
            is_checked: '',
            note: '',
          },
          {
            id: 3,
            label: '알러지 및 미생물',
            is_checked: '',
            note: '',
          },
          {
            id: 4,
            label: '동물, 식물',
            is_checked: '',
            note: '',
          },
        ]
      case '작업특성 요인' :
        return [
          {
            id: 1,
            label: '소음, 초음파, 초저주파음, 진동',
            is_checked: '',
            note: '',
          },
          {
            id: 2,
            label: '종사자 실수(휴먼 에러)',
            is_checked: '',
            note: '',
          },
          {
            id: 3,
            label: '저압 또는 고압상태, 질식 위험, 산소 결핍',
            is_checked: '',
            note: '',
          },
          {
            id: 4,
            label: '중랑물 취급 작업, 반복 작업',
            is_checked: '',
            note: '',
          },
          {
            id: 5,
            label: '불안정한 작업 자세, 작업(조작) 도구',
            is_checked: '',
            note: '',
          },
        ]
      case '작업환경 요인' :
        return [
          {
            id: 1,
            label: '기후, 고온, 한랭',
            is_checked: '',
            note: '',
          },
          {
            id: 2,
            label: '조명, 공간 및 이동통로',
            is_checked: '',
            note: '',
          },
          {
            id: 3,
            label: '주변 종사자, 작업 시간',
            is_checked: '',
            note: '',
          },
          {
            id: 4,
            label: '조직 안전문화',
            is_checked: '',
            note: '',
          },
          {
            id: 5,
            label: '화상',
            is_checked: '',
            note: '',
          },
          {
            id: 6,
            label: '작업(조작) 도구',
            is_checked: '',
            note: '',
          },
        ]

      default:
        return []
      }

    },
  }
}
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}
.mt-component-form {
  margin-top: 15px;
}

/* uploaded File */
.h-upload {
  height: 470px;
}
.upload-content {
  border: $border;
  &:last-child {
    border-left: none;
  }
  &__title {
    height: 54px;
    line-height: 54px;
    text-align: center;
    background: #fafafa;
    border-bottom: $border;
  }
  &__input {
    height: 54px;
    background: #f9f9f9;
    border-top: $border;
    padding: 5px 15px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &__file {
    height: calc(100% - 54px);
    width: 100%;
    padding: 14px;
  }
}
</style>
